"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var sis_inline_communication_service_1 = require("../sis-inline-communication.service");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var abstract_destruction_subject_1 = require("../../abstract-destruction-subject");
var of_1 = require("rxjs/observable/of");
var noop_1 = require("rxjs/util/noop");
var SisInlineTableComboBoxComponent = /** @class */ (function (_super) {
    __extends(SisInlineTableComboBoxComponent, _super);
    function SisInlineTableComboBoxComponent(communicationService, classifierService, kbService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.classifierService = classifierService;
        _this.kbService = kbService;
        _this._isChild = false;
        _this._isDisabled = false;
        _this._selectedValueChange = new core_1.EventEmitter();
        return _this;
    }
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "columnFields", {
        set: function (value) {
            this._columnFields = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "entity", {
        set: function (value) {
            this._entity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "isDisabled", {
        get: function () {
            return this._isDisabled;
        },
        set: function (value) {
            this._isDisabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "readOnly", {
        get: function () {
            return this._readOnly;
        },
        set: function (value) {
            this._readOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "field", {
        get: function () {
            return this._field;
        },
        set: function (value) {
            this._field = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "selectedValue", {
        get: function () {
            return this._selectedValue;
        },
        set: function (value) {
            this._selectedValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "selectedValueChange", {
        get: function () {
            return this._selectedValueChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableComboBoxComponent.prototype, "selectedValueName", {
        get: function () {
            return this._selectedValueName;
        },
        enumerable: true,
        configurable: true
    });
    SisInlineTableComboBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.findParent()
            .pipe(operators_1.mergeMap(function (parentData) {
            if (parentData) {
                _this._parent = parentData[0], _this._parentId = parentData[1];
                _this._isChild = true;
            }
            return _this.loadItems(_this._parentId);
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function () {
            _this.initSelectedValueName();
            _this.proceedWithChildSubscription();
        }, console.error);
    };
    SisInlineTableComboBoxComponent.prototype.itemChanged = function (selectedId) {
        var _this = this;
        if (selectedId) {
            this.classifierService
                .loadClassifier(this._field.getCompoundCategorySystemName(), selectedId)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (classifier) {
                _this._selectedValue = classifier;
                _this._selectedValueChange.emit(classifier);
                _this.communicationService.publishClassifierChange([
                    new idm_kb_service_client_js_1.MetaCategoryId(_this._field.getCompoundCategorySystemName()),
                    _this._entity.getId(),
                    classifier.getId(),
                ]);
            }, console.error);
            this._selectedValueName = this.items
                .find(function (item) { return item.getId() === selectedId; })
                .getName();
        }
        else {
            this._selectedValue = undefined;
            this._selectedValueChange.emit(null);
            this.communicationService.publishClassifierChange([
                new idm_kb_service_client_js_1.MetaCategoryId(this._field.getCompoundCategorySystemName()),
                this._entity.getId(),
                undefined,
            ]);
            this._selectedValueName = undefined;
        }
    };
    SisInlineTableComboBoxComponent.prototype.proceedWithChildSubscription = function () {
        var _this = this;
        if (this._isChild) {
            this.communicationService.classifierObservable
                .pipe(operators_1.filter(function (_a) {
                var category = _a[0], entityId = _a[1];
                return category.getSystemName() ===
                    _this._parent.getSystemName() &&
                    _this._entity.getId() === entityId;
            }), operators_1.mergeMap(function (_a) {
                var id = _a[2];
                _this.itemChanged(undefined);
                return _this.loadItems(id);
            }), operators_1.takeUntil(this.destroySubject$))
                .subscribe(noop_1.noop, console.error);
        }
    };
    SisInlineTableComboBoxComponent.prototype.initSelectedValueName = function () {
        var _this = this;
        if (this._selectedValue) {
            var selectedItem = this._items.find(function (item) {
                return item.getId() === _this._selectedValue.getId();
            });
            if (selectedItem) {
                this._selectedValueName = selectedItem.getName();
            }
            else {
                this.classifierService
                    .getEntityName(this.field.getCompoundCategorySystemName(), this._selectedValue)
                    .pipe(operators_1.first(), operators_1.map(function (name) { return (_this._selectedValueName = name); }), operators_1.catchError(function (err) {
                    _this._selectedValueName = '';
                    console.error(err);
                    throw new Error('selected classifier was not found');
                }))
                    .subscribe(console.log, console.error);
            }
        }
    };
    SisInlineTableComboBoxComponent.prototype.loadItems = function (parentId) {
        var _this = this;
        if (this._isChild && parentId) {
            return this.classifierService
                .loadClassifiersViewByParent(this.field.getCompoundCategorySystemName(), parentId)
                .pipe(operators_1.map(function (value) {
                _this._isDisabled = false;
                _this._items = value;
            }));
        }
        else if (this._isChild) {
            this._isDisabled = true;
            this._items = [];
            return of_1.of(undefined).pipe(operators_1.map(function () {
                return;
            }));
        }
        else {
            return this.classifierService
                .loadClassifiersView(this.field.getCompoundCategorySystemName())
                .pipe(operators_1.map(function (value) {
                _this._items = value;
            }));
        }
    };
    SisInlineTableComboBoxComponent.prototype.findParent = function () {
        var _this = this;
        return this.kbService
            .getMetaFields(this._field.getCompoundCategorySystemName())
            .pipe(operators_1.map(function (classifierMetaFields) {
            return classifierMetaFields.find(function (item) {
                return item.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT;
            });
        }), operators_1.map(function (parent) {
            if (parent === undefined) {
                return undefined;
            }
            return _this._columnFields.find(function (item) {
                return item.getCompoundCategorySystemName() ===
                    parent.getCompoundCategorySystemName();
            });
        }), operators_1.map(function (parentField) {
            if (parentField) {
                var parentClassifier = (_this._entity.getProperty(parentField.getMetaFieldId().getSystemName()).value);
                return [
                    new idm_kb_service_client_js_1.MetaCategoryId(parentField.getCompoundCategorySystemName()),
                    parentClassifier
                        ? parentClassifier.getId()
                        : undefined,
                ];
            }
            else {
                return undefined;
            }
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisInlineTableComboBoxComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisInlineTableComboBoxComponent.prototype, "columnFields", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity),
        __metadata("design:paramtypes", [idm_de_core_frontend_1.Entity])
    ], SisInlineTableComboBoxComponent.prototype, "entity", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisInlineTableComboBoxComponent.prototype, "isDisabled", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisInlineTableComboBoxComponent.prototype, "readOnly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.MetaField])
    ], SisInlineTableComboBoxComponent.prototype, "field", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_classifier_service_client_js_1.Classifier),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.Classifier])
    ], SisInlineTableComboBoxComponent.prototype, "selectedValue", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], SisInlineTableComboBoxComponent.prototype, "selectedValueChange", null);
    SisInlineTableComboBoxComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'inline-table-combo-box',
            template: require('./sis-inline-table-combo-box.component.html'),
        }),
        __metadata("design:paramtypes", [sis_inline_communication_service_1.SisInlineCommunicationService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_kb_service_client_js_1.KbService])
    ], SisInlineTableComboBoxComponent);
    return SisInlineTableComboBoxComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.SisInlineTableComboBoxComponent = SisInlineTableComboBoxComponent;
//# sourceMappingURL=sis-inline-table-combo-box.component.js.map